import { render, staticRenderFns } from "./ExpenseCategories.vue?vue&type=template&id=15ff1b6c&scoped=true&"
import script from "./ExpenseCategories.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategories.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCategories.vue?vue&type=style&index=0&id=15ff1b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff1b6c",
  null
  
)

export default component.exports